import { useEffect, useState } from "react";
import { ConfigOptions, defaultConfigOptions } from "../components/constants";

export default function useConfig(url: string) {
	const [data, setData] = useState<ConfigOptions>(defaultConfigOptions);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		(async function () {
			try {
				setLoading(true);
				const response = await fetch(url);
				const newData = await response.json();
				setData({ ...defaultConfigOptions, ...newData });
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		})();
	}, [url]);

	return { data, error, loading };
}
